<template>
	<v-dialog
		v-model="open"
		:content-class="`ready-to-redeem-discounts-dialog`"
	>
		<v-layout column class="kiosk-modal discount-layout">
			<div class="black-background">
				<v-btn icon class="close-btn" @click="onClose">
					<img  alt="" class="close-image" src="../../../../../static/tid100/images/icons/x-close.svg"/>
				</v-btn>
				<v-layout column wrap justify-space-between class="dialog-body-wrapper">
					<v-layout column class="discount-dialog-body">
						<div class="discount-title">{{ $t('utilityComponents.productAsCompensationCRMModule.readyToRedeemDiscounts') }}</div>
						<v-card v-for="voucher in vouchersData" :key="voucher.id" flat class="discount-product-wrapper">
							<div v-if="vouchersProduct(voucher.productPattern)" class="discount-product">
								<img class="discount-product-image" :src="getProductImage(vouchersProduct(voucher.productPattern))">
								<div class="discount-product-name-price">
									<div class="discount-card-product-name">{{ vouchersProduct(voucher.productPattern).name }}</div>
									<div class="discount-card-product-discount">{{ voucher.discountValue === 100 ? $t('utilityComponents.productAsCompensationCRMModule.gratis') : voucher.discountValue + "Discount" }}</div>
									<div class="discount-price-section">
										<div class="discount-new-price">{{ voucher.discountValue === 100 ? $t('utilityComponents.productAsCompensationCRMModule.free') : voucher.discountValue + "%" }}</div>
									</div>
								</div>
							</div>
							<div v-if="vouchersProduct(voucher.productPattern)" class="discount-product-footer">
								<v-btn :ripple="false"
										@click="addToBasketProductAward(vouchersProduct(voucher.productPattern), voucher.id)"
										class="redeem-discount green-btn"
										primary
										flat>
									{{ $t('utilityComponents.productAsCompensationCRMModule.redeemDiscount') }}
								</v-btn>
								<div class="discount-product-valid">
									{{ $t('utilityComponents.productAsCompensationCRMModule.discountValid') }} {{ voucher.expiryDate }}
								</div>
							</div>
						</v-card>
					</v-layout>
				</v-layout>
			</div>
		</v-layout>
	</v-dialog>
</template>

<script>
/**
 * this one is used in GT2 order presentation basket when ready to reedem button is cliced - it opens dialog with vouchers
 */
import { mapGetters } from "vuex";
import appConfig from "../../../../appconfig";
import ProductSelection from "../../../../domains2/orders/ProductSelection";
import * as actions from "../../../../store/mutation-types";
import {voucherValidationHelper} from "../../../../helper/VoucherValidationHelper";

export default {
	name: "VoucherCartDialog-gt2",
	props: ["show", "onClose", "vouchersData", "getProductImage"],
	data() {
		return {
			productsAsAward: []
		};
	},
	computed: {
		...mapGetters(["featureToggles", "applicationUserLoggedIn", "productCatalog", "tenantSettings"]),
		open: {
			get() {
				return this.show;
			},
			set() {
				this.onClose();
			}
		}

	},
	async mounted() {
		const self = this;
		if(self.featureToggles.enableDiscountsPage && self.applicationUserLoggedIn) {
			for (const item of self.vouchersData) {
				const productIds = item.productPattern;
				self.productsAsAward.push(...productIds.map(x => self.productCatalog.getProduct(x)));
			}
		}
	},
	methods: {
		vouchersProduct(productPattern) {
			if(this.productsAsAward) {
				return this.productsAsAward.find(x => x.id === productPattern[0]);
			}
		},
		async addToBasketProductAward(product, voucherId) {
			const psOptions = {
				expiration: {
					tenantSettings: this.tenantSettings.productSelectionExpiration,
					tenantConfig: appConfig.tenantConfig.productSelectionExpiration
				}
			};
			const productSelection = ProductSelection.createFromProduct(product, psOptions);
			productSelection.quantity = productSelection.quantity || 1;
			productSelection.voucherId = voucherId;
			await this.$store.dispatch(actions.ADD_PRODUCT_SELECTION_TO_CART, productSelection);
			await voucherValidationHelper(this, voucherId);
			this.onClose();
		}
	}
};
</script>

<style lang="scss" scoped>
.v-dialog__content:has(.ready-to-redeem-discounts-dialog) {
	z-index: 9999 !important;
}
/deep/ .ready-to-redeem-discounts-dialog {
	width: 100%;
	height: 100%;
	margin: 0;
	max-height: 100%;
	.discount-layout, .black-background {
		padding-bottom: 0;
	}
	.black-background {
		min-height: 100vh;
		height: auto;
	}
	.discount-layout {
		.close-btn {
			position: absolute;
			top: 0;
			right: 0;
		}
		.dialog-body-wrapper {
			height: 100%;
		}
		.discount-dialog-body {
			color: #FFFFFF;
			.discount-title {
				font-size: 21px;
				line-height: 26px;
				text-align: center;
				padding-top: 50px;
			}
		}
		.discount-dialog-body {
			margin-bottom: 15px;
			flex: 0 1 auto;
		}
		.discount-product-wrapper {
			background-color: #1A1B1E;
			padding: 10px;
			margin: 15px 15px 0;
			.discount-product {
				display: flex;
				.discount-product-image {
					width: 110px;
					height: 110px;
				}
				.discount-product-name-price {
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					width: 100%;
					padding-left: 10px;
					.discount-card-product-name {
						font-size: 18px;
						color: #ffffff;
						font-weight: bold;
					}
					.discount-card-product-discount {
						font-size: 14px;
						color: #FFD800;
						font-weight: bold;
					}
					.discount-price-section {
						display: flex;
						.discount-regular-price {
							background-color: #333333;
							font-size: 20px;
							color: #7B7B7B;
							padding: 7px 15px;
							line-height: 1;
							text-decoration: line-through;
							font-weight: bold;
						}
						.discount-new-price {
							background-color: #FFD800;
							font-size: 20px;
							font-weight: bold;
							padding: 7px 15px;
							line-height: 1;
							color: #000000;
							text-transform: uppercase;
						}
					}
				}
			}
			.discount-product-footer {
				margin-top: 15px;
				.discount-product-valid {
					color: #9B9B9B;
					padding-top: 12px;
				}
			}
		}
	}
}
</style>